import { render, staticRenderFns } from "./SampleMemoryHeat.vue?vue&type=template&id=50996c8e&scoped=true"
import script from "./SampleMemoryHeat.vue?vue&type=script&lang=js"
export * from "./SampleMemoryHeat.vue?vue&type=script&lang=js"
import style0 from "./SampleMemoryHeat.vue?vue&type=style&index=0&id=50996c8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50996c8e",
  null
  
)

export default component.exports